import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import is from 'is_js';

import { AuthContextProvider } from './context/AuthContext';
import AppContext from './context/Context';
import { logError } from './helpers/logger';
import { getLanguage, getSupportedLanguages, setLanguage } from './helpers/utils';
import Routes from './routes';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';

function App() {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  useEffect(() => {
    try {
      const language = getLanguage(false);
      const supportedLanguages = getSupportedLanguages();
      if (!language) {
        const userLanguage = navigator.languages.find((lang) => supportedLanguages.includes(lang));
        if (userLanguage && userLanguage !== 'en') {
          setLanguage(userLanguage);
          window.location.reload();
        }
      }
    } catch (e) {
      logError('App.js navigator.languages', e);
    }
  }, navigator.languages);

  return (
    <AuthContextProvider>
      <Router>
        <Routes />
      </Router>
    </AuthContextProvider>
  );
}

export default App;
